import { useEffect, useRef } from 'react'

import { saveQuizScore } from '@/services/quiz_score'
import type { Profile } from '@/stores'
import { clearPendingQuizScore, getPendingQuizScore } from '@/utils/quiz_pending'
import { isSupabaseConfigured } from '@/utils/supabase'

export const flushPendingQuizScore = async (profile: Profile): Promise<boolean> => {
	const pending = getPendingQuizScore()
	if (!pending || !profile?.barcode) return false
	if (!isSupabaseConfigured()) return false

	await saveQuizScore(profile, pending)
	clearPendingQuizScore()
	return true
}

export const useFlushPendingQuizScore = (
	profile: Profile | null,
	onSaved?: () => void
): void => {
	const flushing = useRef(false)
	const onSavedRef = useRef(onSaved)
	onSavedRef.current = onSaved

	useEffect(() => {
		if (!profile?.barcode || flushing.current) return
		if (!getPendingQuizScore()) return

		flushing.current = true
		flushPendingQuizScore(profile)
			.then(saved => {
				if (saved) onSavedRef.current?.()
			})
			.catch(err => console.error('Failed to save pending quiz score:', err))
			.finally(() => {
				flushing.current = false
			})
	}, [profile])
}
